const getValueFromQueryParams = (name) => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has(name)) {
    return urlParams.get(name);
  }
};

export default getValueFromQueryParams;
